import React, { Component } from 'react';
import { toast } from 'react-toastify';
import ModalDm from '../../components/Modal/ModalDm';
import { pathDmService } from '../../services/Api';

class ModalConfirmacao extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pedido: this.props.pedido
    };
  }

  componentDidMount = async () => {

  };

  atualizaStatusPedido = async (e, status) => {
    const { toggleModal, modal } = this.props;
    const { pedido } = this.state;
    const obj = { "status": status, "lstIdPedido": [pedido] };

    e.preventDefault();
    try {
      await pathDmService("/Pedido/AtualizaStatusPedidoAgencia/", obj);
      await toast.success("Status do pedido atualizado com sucesso.");
      toggleModal(modal);
    } catch (e) {
      await toast.error(`Ocorreu um erro ao alterar o status do pedido: ${e.message}`);
    }
  };

  render() {
    const { modal, isOpen, toggleModal, newStatus } = this.props;
    return (
      <ModalDm
        openModal={() => toggleModal(modal)}
        heading="Confirmação"
        hiddenModal={() => toggleModal(modal)}
        openMd={isOpen}
      >
        <div>
          <div className="bx--modal-header">
            <p className="question">
              Tem certeza que deseja alterar o status do pedido?
            </p>
          </div>
          <div className="bx--modal-footer">
            <div className="bx--row btn-actions">
              <div className="bx--col-md-12 bx--col-xs-12">
                <div className="f-right">
                  <button
                    className="bx--btn btn-secondary-outlined h-sm-margin"
                    type="button"
                    onClick={() => toggleModal(modal)}
                  >
                    Cancelar
                  </button>
                  <button
                    className="bx--btn btn-secondary-color h-sm-margin"
                    type="button"
                    onClick={(e) => this.atualizaStatusPedido(e, newStatus)}
                  >
                    Salvar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ModalDm>
    );
  }
}

export default ModalConfirmacao;


// WEBPACK FOOTER //
// ./src/components/Modal/ModalConfirmacao.js